import React, { useEffect, useState } from 'react'
import { 
  Button,
  Grid,
  makeStyles, 
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { efectorHorariosLimpiar, fetchHorariosDemandaDisponibles } from '../../../../../actions/turnos/efectorHorarios';
import { SelectGeneric } from '../../../../atomic/atoms/Select';
import { HorariosCentroEspecialidad } from './HorariosCentroEspecialidad';

const useStyles = makeStyles((theme) => ({
  grid: {
    padding: 10,
  }
}));

export const DatosCentroEspecialidadHce = ({setParametrizacionSeleccionada, hce}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { especialidadesDemanda, itemsDemanda } = useSelector((state) => state.efectorHorarios);

  const [openModalHorarios, setOpenModalHorarios] = useState(false);
  const [centrosDemanda, setCentrosDemanda] = useState([]);
  const [idEspecialidad, setIdEspecialidad] = useState();
  const [idCentro, setIdCentro] = useState();

  useEffect(() => {
    dispatch( efectorHorariosLimpiar() );
    dispatch( fetchHorariosDemandaDisponibles(null) );
  }, [dispatch]);

  useEffect(() => {    
    if(especialidadesDemanda.length === 1) handleInputChangeEspecialidad({target: {value: especialidadesDemanda[0]?.idEspecialidad}});
  }, [especialidadesDemanda]);

  useEffect(() => {
    if(itemsDemanda.length > 0){
      const idsCentroTmp = [...new Set(itemsDemanda.map(item => item.idCentroMedico))];
      if(idsCentroTmp.length === 1){
        handleInputChangeCentro({target: {value: idsCentroTmp[0]}});
      }else if(idsCentroTmp.filter(s => s === hce?.idCm).length === 1){
        handleInputChangeCentro({target: {value: hce?.idCm}});
      }
    }
  }, [itemsDemanda]);

  useEffect(() => {
    if(itemsDemanda.length > 0){
      const idsCentroTmp = [...new Set(itemsDemanda.map(item => item.idCentroMedico))];

      const items = idsCentroTmp.map( i => {
        const centro = itemsDemanda.find(s => s.idCentroMedico === i);
        const horariosCentro = itemsDemanda.filter(s => s.idCentroMedico === i);

        return {
            idCentroMedico: centro.idCentroMedico,
            centroMedico: centro.centroMedico,
            horariosCentro,
        }
      });

      setCentrosDemanda(items);
    }
  }, [itemsDemanda]);

  const handleInputChangeEspecialidad = (e) => {        
    setIdEspecialidad(e.target.value);
    setParametrizacionSeleccionada({idEspecialidad: e.target.value});
    if(e.target.value)
      dispatch( fetchHorariosDemandaDisponibles(e.target.value) );    
  }

  const handleInputChangeCentro = (e) => {    
    setIdCentro(e.target.value);
    setParametrizacionSeleccionada({idEspecialidad: idEspecialidad, idCentro: e.target.value});
  }

  // console.log(parametrizacionSeleccionada);

  return (
    <>  
      <Grid item xs={4} className={classes.grid} style={{paddingRight: 0}}>
        <SelectGeneric
          label="Especialidad"
          name='idEspecialidad'
          value={idEspecialidad ?? ''}
          onChange={handleInputChangeEspecialidad}
          menuItems={especialidadesDemanda.map(s => ({ value: s.idEspecialidad, label: s.especialidad }))}
        />
      </Grid>
      <Grid item xs={6} className={classes.grid}>
        <SelectGeneric
          label="Centro Médico Sugerido"
          value={idCentro ?? ''}
          onChange={handleInputChangeCentro}
          menuItems={centrosDemanda.map(s => (
            { 
              value: s.idCentroMedico, 
              label: `${s.centroMedico}` 
            }
          ))}
        />
      </Grid>
      <Grid item xs={2} className={classes.grid} style={{textAlign: 'end'}}>
        <HorariosCentroEspecialidad 
          openModalHorarios={openModalHorarios}
          setOpenModalHorarios={setOpenModalHorarios}
          horarios={itemsDemanda.filter(s => s.idCentroMedico === idCentro)}
        />
        <Button
          variant="contained"
          style={{marginTop: 30}}
          disabled={!idEspecialidad || !idCentro}
          onClick={() => setOpenModalHorarios(true)}
          color="secondary"
        >
          Horarios
        </Button>        
      </Grid>
    </>
  )
}
